export default "__VITE_ASSET__XgxuWhNS__"